module.exports = __webpack_public_path__ + "media/images/photo/Residential/Residential-02-c5a749bcbd2a11c73fcef9b45666b921.png";